module.exports = __webpack_public_path__ + "img/terms-conditions.653bd1f0.png";